function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M23.723 47.055H12.057a2.333 2.333 0 0 1-2.334-2.334V12.055a2.333 2.333 0 0 1 2.334-2.334h11.666v7a7 7 0 0 0 7 7h9.334a2.333 2.333 0 0 0 2.146-1.446 2.333 2.333 0 0 0-.49-2.544l-14-14a2.497 2.497 0 0 0-.653-.443.747.747 0 0 0-.21 0l-.653-.233h-14.14a7 7 0 0 0-7 7V44.72a7 7 0 0 0 7 7h11.666a2.333 2.333 0 0 0 0-4.666ZM28.39 13.01l6.043 6.044h-3.71a2.333 2.333 0 0 1-2.333-2.334v-3.71Zm2.333 17.71a2.333 2.333 0 0 0-2.333-2.333H16.723a2.334 2.334 0 0 0 0 4.667H28.39a2.333 2.333 0 0 0 2.333-2.334Zm-14-7h2.334a2.333 2.333 0 0 0 0-4.666h-2.334a2.333 2.333 0 1 0 0 4.666Zm0 14a2.333 2.333 0 1 0 0 4.667h4.667a2.333 2.333 0 1 0 0-4.667h-4.667Zm30.334-1.913v-.42a7 7 0 1 0-14 0v.42a7 7 0 0 0-4.667 6.58v2.333a7 7 0 0 0 7 7h9.333a7 7 0 0 0 7-7v-2.333a7 7 0 0 0-4.666-6.58Zm-7-2.753a2.333 2.333 0 0 1 2.333 2.333h-4.667a2.333 2.333 0 0 1 2.334-2.333Zm7 11.666a2.333 2.333 0 0 1-2.334 2.334H35.39a2.333 2.333 0 0 1-2.333-2.334v-2.333a2.333 2.333 0 0 1 2.333-2.333h9.333a2.333 2.333 0 0 1 2.334 2.333v2.333Z",
  fill: "#F2F2F2"
});

function SvgIconContract({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContract);
export default __webpack_public_path__ + "static/media/icon-contract.4d9042e967ea56455d6b97361bab4b13.svg";
export { ForwardRef as ReactComponent };